import { AppConfiguration } from "./app-configuration";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

import { responseIsJson, callApiDefaultOnFail, callApi, callApiAsync } from '../../shared/helpers/api-helpers';
import * as App from '../../index';

const GetAccessToken = (onGetToken) => {
  const appSiteConfig = AppConfiguration.Setting();

  let accessToken = null;

  const instance = App.msalInstance;
  let userAccount = instance.getActiveAccount();

  const accessTokenRequest = {
    scopes: [appSiteConfig.scopes],
    account: userAccount
  };

  instance.acquireTokenSilent(accessTokenRequest)
    .then((accessTokenResponse) => {
      accessToken = accessTokenResponse.accessToken;;
      onGetToken(accessToken);
    })
    .catch((error) => {
      if (error instanceof InteractionRequiredAuthError) {
        accessToken = instance.acquireTokenRedirect(accessTokenRequest);
        onGetToken(accessToken);
      }
      console.log(error);
    });

};

const getVersionNo = () => {
  const appSiteConfig = AppConfiguration.Setting();
  const version = 'build:' + appSiteConfig.appVersion.build + ';major:' + appSiteConfig.appVersion.major + ';minor:' + appSiteConfig.appVersion.minor

  return version;
};

const getUserId = () => {
  const userName = sessionStorage.getItem('userName');

  return userName;
};

const apiGet = (apiUrl, showLoading, hideLoading, messageBox, onSuccess, onFail) => {
  const onGetToken = (result) => {
    const requestInit = {
      method: 'get',
      headers: { 'Content-Type': 'application/json; version=' + getVersionNo(), 'Authorization': 'Bearer ' + result, 'Version': getVersionNo(), 'User': 'UserName ' + getUserId() }
    };

    callApi(apiUrl, requestInit, showLoading, hideLoading, messageBox, onSuccess, onFail);
  };

  GetAccessToken(onGetToken);
};

const apiGetAsynch = (apiUrl, showLoading, hideLoading, messageBox, onSuccess, onFail) => {
  const onGetToken = (result) => {
    const requestInit = {
      method: 'get',
      headers: { 'Content-Type': 'application/json; version=' + getVersionNo(), 'Authorization': 'Bearer ' + result, 'Version': getVersionNo(), 'User': 'UserName ' + getUserId() }
    };

    callApiAsync(apiUrl, requestInit, showLoading, hideLoading, messageBox, onSuccess, onFail);
  };

  GetAccessToken(onGetToken);
};

const apiPost = (apiUrl, headerBody, showLoading, hideLoading, messageBox, onSuccess, onFail) => {
  const onGetToken = (result) => {
    const requestInit = {
      method: 'post',
      headers: { 'Content-Type': 'application/json; version=' + getVersionNo(), 'Authorization': 'Bearer ' + result, 'Version': getVersionNo(), 'User': 'UserName ' + getUserId() },
      body: headerBody
    };

    callApi(apiUrl, requestInit, showLoading, hideLoading, messageBox, onSuccess, onFail);
  };

  GetAccessToken(onGetToken);
};

const apiPostFile = (apiUrl, headerBody, showLoading, hideLoading, messageBox, onSuccess, onFail) => {
  const onGetToken = (result) => {
    const requestInit = {
      method: 'post',
      headers: { 'Accept': 'application/json; version=' + getVersionNo(), 'Authorization': 'Bearer ' + result, 'Version': getVersionNo(), 'User': 'UserName ' + getUserId() },
      body: headerBody
    };

    callApi(apiUrl, requestInit, showLoading, hideLoading, messageBox, onSuccess, onFail);
  };

  GetAccessToken(onGetToken);
};

export { getVersionNo, getUserId, responseIsJson, callApiDefaultOnFail, apiGet, apiPost, apiPostFile, apiGetAsynch }
